import { render, staticRenderFns } from "./PreviewSecurity.vue?vue&type=template&id=0ccbf936&scoped=true"
import script from "./PreviewSecurity.vue?vue&type=script&lang=js"
export * from "./PreviewSecurity.vue?vue&type=script&lang=js"
import style0 from "./PreviewSecurity.vue?vue&type=style&index=0&id=0ccbf936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbf936",
  null
  
)

export default component.exports